import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ProgressFacade } from '../facades/progress.facade';

export function progressCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const progressFacade = inject(ProgressFacade);
        progressFacade.clear();

        return true;
    };
}
